import { render, staticRenderFns } from "./EnrolmentQuestionProgramGradeEditor.vue?vue&type=template&id=5f1df254&scoped=true"
import script from "./EnrolmentQuestionProgramGradeEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentQuestionProgramGradeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1df254",
  null
  
)

export default component.exports